import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { ForeignBusinessConferencesContactsModel } from 'forms/sections/foreign/business/conferences/types';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import { EmptyListInstance } from 'forms/shared/models';
import BranchCollection from 'components/Form/BranchCollection';
import ConferenceContactsItem from './ConferenceContactsItem';

interface Props extends ValidationElementProps, Partial<ForeignBusinessConferencesContactsModel> {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
}

export default class ConferenceContacts extends ValidationElement<Props> {
  update = (queue: Partial<ForeignBusinessConferencesContactsModel>) => {
    this.props.onUpdate({
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (items: ForeignBusinessConferencesContactsModel['List']) => {
    this.update({
      List: items,
    });
  };

  render() {
    const attribute = `${this.props.attribute}.List`;
    return (
      <div className="foreign-business-conferences-contacts">
        <BranchCollection
          attribute={attribute}
          label={i18n.t('foreign.business.conferences.heading.contact')}
          appendLabel={i18n.t('foreign.business.conferences.heading.contact2')}
          help="foreign.business.conferences.help.contact"
          className="has-foreign-contacts"
          branchClassName="no-margin-bottom"
          {...this.props.List}
          onUpdate={this.updateList}
          required={this.props.required}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
        >
          <ConferenceContactsItem
            attribute={attribute}
            name="Item"
            bind
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          />
        </BranchCollection>
      </div>
    );
  }
}

ConferenceContacts.defaultProps = {
  name: 'Contacts',
  List: EmptyListInstance,
  onUpdate: () => {},
  onError: (value, arr) => arr,
};
